import type { LayoutProps } from '../../types';

import * as React from 'react';
import { LayoutB as LayoutComponent } from '../../layouts/LayoutB';

export function Layout(props: LayoutProps) {
  const { children, pageContext } = props;
  return (
    <LayoutComponent pageContext={pageContext}>
      {children}
    </LayoutComponent>
  );
}
